import { ChevronRight } from '@ixigo/icons';
import ListItem from '@ixigo/iui/ListItem';
import ListItemIcon from '@ixigo/iui/ListItemIcon';
import ListItemText from '@ixigo/iui/ListItemText';
import { FC, Fragment } from 'react';
import { ServiceListProps } from './index.types';

const MobServiceList: FC<ServiceListProps> = ({ data, onClick }) => (
    <div className='flex flex-col'>
        {data.map((item, index) => (
            <Fragment key={item._id}>
                <ListItem className='!px-0 !py-15' onClick={() => onClick(item)}>
                    <ListItemIcon>
                        <div dangerouslySetInnerHTML={{ __html: item.iconSvg }} />
                    </ListItemIcon>
                    <ListItemText primary={item.header} secondary={item.subHeader} className='' />
                    <ListItemIcon>
                        <ChevronRight />
                    </ListItemIcon>
                </ListItem>
                {data.length - 1 !== index && <div className='self-end w-[calc(100%-50px)] h-px bg-charcoal-100' />}
            </Fragment>
        ))}
    </div>
);

export default MobServiceList;
